import { Injectable } from '@angular/core';

/** Name and settings of a new dynamic list whose filter is set on the search page. */
export interface NewListDraft {
  name: string;
  description: string;
  favourite: boolean;
  alerts: boolean;
}

/**
 * Keeps the new dynamic list of the "New list" dialog while the user sets its
 * filter on the search page (`/search?mode=new-list`). In memory only; after
 * a reload the search page asks for name and description again.
 */
@Injectable({ providedIn: 'root' })
export class NewListDraftService {
  public draft: NewListDraft | null = null;
}
